import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "./../../../redux/rootReducers";
import { resetGstDetails, resetServicesError } from "./../../../redux/services";
import { getGstInfoAction } from "./../../../redux/services/index";
import { ServicesInput } from "../../../components/Services";
import { gstDetails } from "../../../redux/services/serviceTypes";
import { getGstInfoType } from "../../../commonTypes/serviceTypes";
import { Loader, CommonHeader } from "../../../components/commons";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { GetPathBeforeClientCode } from "../../../components/commons/UserManagement";

type AppProps = {
  dispatchGstDetailsAction: (data: getGstInfoType) => void;
  dispachGstErrorReset: () => void;
  dispatchResetServicesError: () => void;
  gstDetails: gstDetails | any;
  fetching: any;
  error: any;
  token: string | null;
  history: any;
};

const GstInfo = ({
  dispatchGstDetailsAction,
  dispatchResetServicesError,
  dispachGstErrorReset,
  gstDetails,
  fetching,
  error,
  token,
  history,
}: AppProps) => {
  const [gstNumber, setGstNumber] = useState("");
  const [isGstInfoUrlPresent, setIsGstInfoUrlPresent] = useMenuCheck();
  const url = history?.location?.pathname;

  useEffect(() => {
    setIsGstInfoUrlPresent(GetPathBeforeClientCode(url), "url");
    dispatchResetServicesError();
    dispachGstErrorReset();
  }, []);

  useEffect(() => {
    if (isGstInfoUrlPresent === false) {
      history.push("/access-denied");
    }
  }, [isGstInfoUrlPresent]);

  const gstInfo = () => {
    if (token) {
      const finalData = {
        gstNumber,
        token,
      };

      dispatchGstDetailsAction(finalData);
    }
  };

  const handleGst = (event: any) => {
    setGstNumber(event?.target.value);
  };

  return (
    <>
      <div className="ifsc-wrap">
        <CommonHeader title="Search GST Number" />
        <div className="row">
          <div className="col-4" style={{ borderRadius: "8px" }}>
            <ServicesInput
              handleChange={handleGst}
              placeholder="GST No."
              serviceType={gstNumber}
              autoFocus
            />
            <button
              disabled={gstNumber && gstNumber?.length > 14 ? false : true}
              className="btn btn-primary w-100 mt-2"
              onClick={gstInfo}
            >
              Submit
            </button>
          </div>

          {gstDetails ? (
            <div className="col-8">
              <table className="table table-bordered table-border-radius">
                <tbody>
                  <tr>
                    <th style={{ width: "30%" }}>Trade Name</th>{" "}
                    <td className="centre">{gstDetails.trade_name}</td>
                  </tr>

                  <tr>
                    <th>Nature of Business</th>{" "}
                    <td className="branch">{gstDetails.nature_of_business}</td>
                  </tr>

                  <tr>
                    <th>Legal Name</th>{" "}
                    <td className="micr">
                      {gstDetails.legal_name_of_business}
                    </td>
                  </tr>

                  <tr>
                    <th>Address</th>{" "}
                    <td className="address">{gstDetails.address}</td>
                  </tr>

                  <tr>
                    <th>State Jurisdiction Code</th>{" "}
                    <td className="address">
                      {gstDetails.state_jurisdiction_code}
                    </td>
                  </tr>
                  <tr>
                    <th>State Jurisdiction Range</th>{" "}
                    <td className="address">
                      {gstDetails.state_jurisdiction_range}
                    </td>
                  </tr>
                  <tr>
                    <th>Central Jurisdiction Code</th>{" "}
                    <td className="address">
                      {gstDetails.central_jurisdiction_code}
                    </td>
                  </tr>
                  <tr>
                    <th>Central Jurisdiction</th>{" "}
                    <td className="address">
                      {gstDetails.central_jurisdiction}
                    </td>
                  </tr>
                  <tr>
                    <th>Registration Type</th>{" "}
                    <td className="address">{gstDetails.registration_type}</td>
                  </tr>
                  <tr>
                    <th>Registration Date</th>{" "}
                    <td className="address">{gstDetails.registration_date}</td>
                  </tr>
                  <tr>
                    <th>Constitution of Business</th>{" "}
                    <td className="address">
                      {gstDetails.constitution_of_business}
                    </td>
                  </tr>
                  <tr>
                    <th>Effective date of Cancellation</th>{" "}
                    <td className="address">
                      {gstDetails.effective_date_of_cancellation}
                    </td>
                  </tr>
                  <tr>
                    <th>Gst Number</th>{" "}
                    <td className="address">{gstDetails.gstin}</td>
                  </tr>
                  <tr>
                    <th>Status</th>{" "}
                    <td className="address">{gstDetails.status}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : error ? (
            <div className="col-8">
              <div className="card p-5 w-100">
                <h3 className="error">
                  {!!error ? error : "No result Found!"}
                </h3>
              </div>
            </div>
          ) : null}
          {fetching && <Loader />}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  gstDetails: state.services.gstDetails,
  fetching: state.services.fetching,
  error: state.services.error,
  token: state.auth.token,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGstDetailsAction: (data: getGstInfoType) =>
    dispatch(getGstInfoAction(data)),
  dispachGstErrorReset: () => dispatch(resetGstDetails()),
  dispatchResetServicesError: () => dispatch(resetServicesError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GstInfo);
